module.exports = "<p>\n  individual-vendor-vehicle-gallery works!\n</p>\n"